import React from "react";
import { Button, Link, Grid, Typography, Box, Container, Accordion, AccordionSummary, AccordionDetails, IconButton, Drawer, List, ListItem, ListItemButton } from "@mui/material";
import { withTranslation } from 'react-i18next';
import { Trans } from 'react-i18next'; // 1. Import Trans
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactComponent as GraphIcon } from "./assets/graph.svg";
import { ReactComponent as HomeIcon } from "./assets/home.svg";
import { ReactComponent as VectorIcon } from "./assets/Vector.svg";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import WisdomLogo from "./assets/wisdomLogo.png";
import whiteHeart from "./assets/whiteHeart.png";
import topArrow from "./assets/topArrow.png";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EnrollIcon from "./assets/images/enroll-icon.svg";

import ResearchCard from './components/ResearchCard';
import { researchEntries } from './data/content';

// Footer
import Footer from './components/Footer';
import MobileDrawer from './components/MobileDrawer';
import WebAppHeader from "./components/WebAppHeader";

export class Publications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
    };
  }

  toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ drawerOpen: open });
    console.log("Drawer opening!")
  };

  componentDidMount() {
    this.setState({ isLoaded: true });
  }

  handleGoHome = () => {
    console.log("handleGoHome called");
    console.log("this.props.onClickGoToPage:", this.props.onClickGoToPage);
    console.log("Calling onClickGoToPage with 'Landing'");
    // onClickGoToPage returns a function, so we need to call that returned function
    const eventHandler = this.props.onClickGoToPage("Landing");
    eventHandler(); // Call the returned event handler function
    console.log("Event handler called");
  };

   changeLanguage = (lng) => {
    this.props.i18n.changeLanguage(lng);
  };

  

  render() {

      const { t, i18n } = this.props;


    if (this.state.isLoaded) {
      return (
        <Box sx={{ 
          minHeight: "100vh", 
          display: "flex", 
          flexDirection: "column",
          justifyContent: "space-between"
        }}>
          {/* Header */}
        <WebAppHeader 
            t={t}
            i18n={i18n}
            view={this.props.view}
            changeLanguage={this.changeLanguage}
            onClickGoToPage={this.props.onClickGoToPage}
            onOpenDrawer={this.toggleDrawer(true)}
            Logo={WisdomLogo}
            icons={{
              HomeIcon,
              InfoOutlinedIcon,
              GroupsOutlinedIcon,
              VectorIcon,
              PostAddOutlinedIcon
            }}
          />

          {/* Mobile Navigation */}
          <MobileDrawer 
              open={this.state.drawerOpen}
              onClose={this.toggleDrawer(false)}
              t={t}
              i18n={i18n} // Passed from this.props
              changeLanguage={this.changeLanguage} // Passed from your class method
              currentView={this.props.view}
              onClickGoToPage={this.props.onClickGoToPage}
              icons={{
                HomeIcon,
                InfoOutlinedIcon,
                GroupsOutlinedIcon,
                VectorIcon,
                PostAddOutlinedIcon
              }}
            />
         
          {/* Main Content */}
          <Container maxWidth="lg" sx={{ mt: 4, mb: 6, minHeight: { xs: "60vh", sm: "60vh", md: "auto" }, flex: 1 }}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: "2.5rem", sm: "2rem", xs: "1.5rem" },
                    fontWeight: 700,
                    color: "#221F73",
                    textAlign: "center",
                    mb: 4,
                  }}
                >
                  {/* Publications */}
                   {t('pubs.publications')}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { md: "18px", sm: "16px", xs: "14px" },
                    lineHeight: 1.6,
                    color: "#333",
                    textAlign: "center",
                    mb: 6,
                  }}
                >
                <Trans
                        i18nKey="pubs.mission" 
                        components={{
                          pink: (
                            <Link 
                              onClick={() => {
                      const eventHandler = this.props.onClickGoToPage("FAQ");
                      eventHandler();
                    }}
                              underline="hover"
                              sx={{ 
                                color: "#D80C8C", 
                                fontWeight: "600",
                                cursor: "pointer" 
                              }} 
                            />
                          )
                        }}
                      />
                </Typography>

                {/* Posters Section */}
                <Box>
                  {researchEntries.map((entry) => (
                    <ResearchCard 
                      key={entry.id}
                      title={entry.title}
                      authors={entry.authors}
                      date={entry.date}
                      finding={entry.finding}
                      findingHighlight={entry.findingHighlight}
                      highlight_link={entry.highlight_link}
                      pdf_link={entry.pdf_link}
                      category={entry.category}

                    />
                  ))}
                </Box>
                {/* End of Posters Section */}
           

              </Grid>
            </Grid>
          </Container>


          {/* Footer */}
          {/* Inside your render return, at the bottom */}
          <Footer 
            t={t} 
            onClickGoToPage={this.props.onClickGoToPage} 
            whiteHeart={whiteHeart} 
            topArrow={topArrow} 
          />
        
        </Box>
      );
    } else {
      return <div>Loading...</div>;
    }
  }
}

export default withTranslation()(Publications);